export namespace TableOption {
	export const CURRENT_PAGE = 1;
	export const DEFAULT_SIZE = 15;
	export const PAGE_SIZE_OPTION = [10, 15, 20];
}
